<template>
    <div class="footer">
        <div class="_content footer-top">
          <div class="left">
            <img class="logo" src="https://hwysource.yunongyun.com/gwang/img/logo2.png" alt="">
            <div>
              <div>联系方式：176-8666-0369</div>
              <div>地址：济南市历下区龙奥西路1号银丰财富广场A座</div>
              <div>鲁担裕农（山东）科技服务有限公司</div>
            </div>
          </div>
          <div class="right">
            <div class="qrcode">
              <img src="https://hwysource.yunongyun.com/gwang/img/gongzhonghao.png" alt="">
            </div>
            <div>鲁担裕农服务号</div>
          </div>
        </div>
        <div class="footer-line"></div>
        <div class="_content footer-bottom">
          <div @click="goTo('https://beian.miit.gov.cn')" style="cursor: pointer;">鲁ICP备2023014545号-5</div>
          <div class="line"></div>
          <div>Copyright &copy; {{$dayjs().format('YYYY')}} 鲁担裕农版权所有</div>
          <div class="line"></div>
          <div>本网站已全面支持IPv6</div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "pagefooter",
    data() {
      return {

      };
    },
    methods: {
      goTo(url) {
        window.open(url, '_blank')
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .footer {
    background: #292F2D;
    .footer-top{
      display: flex;
      justify-content: space-between;
      padding-top: 35px;
      padding-right: 180px;
      padding-bottom: 35px;
      box-sizing: border-box;
      .left{
        display: flex;
        .logo{
          width: 125px;
          height: 47px;
          margin-right: 25px;
        }
        div{
          padding-top: 8px;
          div{
            font-size: 14px;
            line-height: 22px;
            color: rgba(255,255,255,0.9);
            margin-bottom: 15px;
          }
        }
      }
      .right{
        width: 110px;
        height: 130px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        align-items: center;
        flex-direction: column;
        background: rgba(255,255,255,0.38);
        border-radius: 2px;
        font-size: 14px;
        line-height: 20px;
        color: rgba(255,255,255,0.9);
        .qrcode{
          width: 83px;
          height: 83px;
          background: #FFFFFF;
          border-radius: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 8px;
          img{
            width: 77px;
            height: 77px;
          }
        }
      }
    }
    .footer-line{
      width: 100%;
      height: 1px;
      background: rgba(0,0,0,0.29);
    }
    .footer-bottom{
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      line-height: 1.5;
      color: rgba(255,255,255,0.9);
      padding: 15px 0;
      .line{
        background: rgba(255,255,255,0.55);
        margin: 0 15px;
        width: 2px;
        height: 15px;
      }
    }
  }
  </style>